import api from './api';
import type { ClienteDto } from '@/types/cliente';

export const clientesApi = {
  findByDni: (dni: string) =>
    api.get<ClienteDto>('/clientes', { params: { dni } }).then((r) => r.data),
};
